import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="g-bg-main-light-v1">
        <div className="g-brd-bottom g-brd-secondary-light-v1">
          <div className="container g-pt-50">
            <div className="row justify-content-center g-mb-30 g-mb-0--md">
              
              <div className="col-sm-5 col-md-3 g-mb-30 g-mb-0--sm">
                <h2 className="h5 g-color-gray-light-v3 mb-4">Contacts</h2>

                <ul className="list-unstyled g-color-gray-dark-v5 g-font-size-13">
                  <li className="media my-3">
                    <i className="d-flex mt-1 mr-3 icon-hotel-restaurant-235 u-line-icon-pro"></i>
                    <div className="media-body">
                      Antonia Vivaldiego 36/9<br/>Wroclaw, Poland
                    </div>
                  </li>
                  <li className="media my-3">
                    <i className="d-flex mt-1 mr-3 icon-communication-062 u-line-icon-pro"></i>
                    <div className="media-body">
                      bookik.pl@gmail.com
                    </div>
                  </li>
                  <li className="media my-3">
                    <i className="d-flex mt-1 mr-3 icon-communication-033 u-line-icon-pro"></i>
                    <div className="media-body">
                      +48 881 650 971
                    </div>
                  </li>
                </ul>
              </div>
              <div className="col-6 col-md-3 g-mb-30">
                <h2 className="h5 g-color-gray-light-v3 mb-4">Follow Us On:</h2>

                <ul className="list-inline mb-50">
                  <li className="list-inline-item g-mr-2">
                    <a className="u-icon-v1 u-icon-slide-up--hover g-color-gray-dark-v4 g-color-white--hover g-bg-facebook--hover rounded" href="https://www.facebook.com/bookikpl" target="_blank" rel="noopener noreferrer">
                      <i className="g-font-size-18 g-line-height-1 u-icon__elem-regular fa fa-facebook"></i>
                      <i className="g-color-white g-font-size-18 g-line-height-0_8 u-icon__elem-hover fa fa-facebook"></i>
                    </a>
                  </li>
                  <li className="list-inline-item g-mx-2">
                    <a className="u-icon-v1 u-icon-slide-up--hover g-color-gray-dark-v4 g-color-white--hover g-bg-instagram--hover rounded" href="https://www.instagram.com/bookik.pl" target="_blank" rel="noopener noreferrer">
                      <i className="g-font-size-18 g-line-height-1 u-icon__elem-regular fa fa-instagram"></i>
                      <i className="g-color-white g-font-size-18 g-line-height-0_8 u-icon__elem-hover fa fa-instagram"></i>
                    </a>
                  </li>
                  {/* <li className="list-inline-item g-mx-2">
                    <a className="u-icon-v1 u-icon-slide-up--hover g-color-gray-dark-v4 g-color-white--hover g-bg-google-plus--hover rounded" href="#!">
                      <i className="g-font-size-18 g-line-height-1 u-icon__elem-regular fa fa-google-plus"></i>
                      <i className="g-color-white g-font-size-18 g-line-height-0_8 u-icon__elem-hover fa fa-google-plus"></i>
                    </a>
                  </li> */}
                  {/* <li className="list-inline-item g-mx-2">
                    <a className="u-icon-v1 u-icon-slide-up--hover g-color-gray-dark-v4 g-color-white--hover g-bg-linkedin--hover rounded" href="#!">
                      <i className="g-font-size-18 g-line-height-1 u-icon__elem-regular fa fa-linkedin"></i>
                      <i className="g-color-white g-font-size-18 g-line-height-0_8 u-icon__elem-hover fa fa-linkedin"></i>
                    </a>
                  </li> */}
                </ul>
                <ul className="list-inline g-color-gray-dark-v5 g-font-size-25 mb-0">
                  <li className="list-inline-item g-cursor-pointer mr-1">
                    <i className="fa fa-cc-visa" title="" data-toggle="tooltip" data-placement="top" data-original-title="Visa"></i>
                  </li>
                  <li className="list-inline-item g-cursor-pointer mx-1">
                    <i className="fa fa-cc-paypal" title="" data-toggle="tooltip" data-placement="top" data-original-title="Paypal"></i>
                  </li>
                  <li className="list-inline-item g-cursor-pointer mx-1">
                    <i className="fa fa-cc-mastercard" title="" data-toggle="tooltip" data-placement="top" data-original-title="Master Card"></i>
                  </li>
                  <li className="list-inline-item g-cursor-pointer ml-1">
                    <i className="fa fa-cc-stripe" title="" data-toggle="tooltip" data-placement="top" data-original-title="Stripe"></i>
                  </li>
                </ul>
              </div>
              <div className="col-6 col-md-3 g-mb-30">
                <h2 className="h5 g-color-gray-light-v3 mb-4">Legal</h2>
                <div className="g-font-size-13 mb-0">
                  <p className="mb-2"><Link to="/terms" className="g-color-gray-dark-v5 g-font-size-13 ">Terms & Conditions</Link></p>
                  <p className="mb-2"><Link to="/privacy" className="g-color-gray-dark-v5 g-font-size-13 ">Privacy Policy</Link></p>
                </div>
                <p className="g-font-size-13 mb-0">2025 © Bookik. All Rights Reserved.</p>
              </div>
              
            </div>
          </div>
        </div>
      </footer>
    )
}

export default Footer;